import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

import NotificationBanner from '../NotificationBanner/NotificationBanner';
import { statusNotificationInstructionCompletedClosed } from '../../redux/modules/notificationTracking';
import { getFirebaseUid } from '../../redux/selectors';
import { getCompleteAndUnseenWithdrawalInstructions } from '../../redux/selectors/investmentAdvice';
import { getIsCustomerOngoing } from '../../redux/selectors/experience';

const WithdrawalUpdateNotification = ({
  uid,
  hasCompleteAndUnseenWithdrawalInstructions,
  isCustomerOngoing,
  dispatchStatusNotificationInstructionCompletedClosed,
}) => {
  // TODO: when the dashboard is ready:
  // Update auto-message with plan activity link
  //    -> instructionIsForWithdrawal message body in comms-controller

  const dispatchCallback = () => {
    dispatchStatusNotificationInstructionCompletedClosed(
      uid,
      get(hasCompleteAndUnseenWithdrawalInstructions, '0._id', isCustomerOngoing),
    );
  };

  return (
    <NotificationBanner
      alertCategory={'Green'}
      alertTitle={'Withdrawal complete'}
      alertDescription={'We have finished processing your withdrawal request. Typically, you should have the funds in your bank account within 10 working days.'}
       // if scroll to a section is required, use: /plan-activity/#otherInstructions
      ctaButtonOptions={{
        label: 'View my plan activity',
        link: '/plan-activity',
        handleClick: dispatchCallback,
      }}
      closeButtonOptions={{
        handleClick: dispatchCallback,
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  uid: getFirebaseUid(state),
  isCustomerOngoing: getIsCustomerOngoing(state),
  hasCompleteAndUnseenWithdrawalInstructions: getCompleteAndUnseenWithdrawalInstructions(state),
});

const mapDispatchToProps = {
  dispatchStatusNotificationInstructionCompletedClosed:
    statusNotificationInstructionCompletedClosed,
};

export default connect(mapStateToProps, mapDispatchToProps)(WithdrawalUpdateNotification);
